import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const handleGoBack = () => {
        // Со страницы списка документов (домашняя после входа) «Назад» уводит на главную;
        // история прохода сбрасывается уже на главной (см. RouteList).
        if (location.pathname.startsWith("/printing/show_list/user")) {
            navigate("/");
            return;
        }
        // React Router (BrowserRouter) хранит позицию в стеке в window.history.state.idx.
        // Если idx > 0 — внутри приложения есть куда вернуться, идём по реальной истории
        // (пошагово), а не прыгаем сразу в главное меню.
        const canGoBack = (window.history.state?.idx ?? 0) > 0;
        if (canGoBack) {
            navigate(-1);
        } else if (location.state?.from) {
            navigate(location.state.from); // запасной путь на «корне» истории
        } else {
            navigate("/");
        }
    };

    const isHomePage = location.pathname === "/" || location.pathname === "/printing/show_list";

    return (
        <footer className="bg-[#EDEFF4] fixed bottom-0 w-full h-[6vh] px-[2.4vw] flex justify-between items-center">
            {isHomePage ? (
                <p className="w-full text-center text-[1.4vh] font-sans font-semibold text-[#7B8290]">
                    {t("footer.copyright")}
                </p>
            ) : (
                <>
                    <button
                        onClick={handleGoBack}
                        className="flex items-center gap-[0.8vw] bg-white rounded-full shadow-[0_0.5vh_2vh_rgba(18,22,31,0.08)] px-[2.8vw] py-[0.9vh] text-[#12161F] font-sans font-bold text-[2vh]"
                    >
                        <svg
                            className="w-[2.2vh] h-[2.2vh]"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M19 12H5M11 6l-6 6 6 6" />
                        </svg>
                        {t("footer.back")}
                    </button>
                    <span className="text-[1.4vh] font-sans font-semibold text-[#7B8290]">
                        {t("footer.copyright")}
                    </span>
                </>
            )}
        </footer>
    );
}

export default Footer;